<template>
  <div class="content">
    <van-cell-group inset>
      <van-cell
        :title="item.name"
        is-link
        @click="myCheck(item)"
        v-for="(item, index) in dataList"
        :key="index"
        :to="item.path"
      >
        <template #icon>
          <van-image :src="item.img" width="30" height="30" />
        </template>
      </van-cell>
    </van-cell-group>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dataList: [
        {
          name: "我参与的抽奖",
          img: require("./../assets/img/lottery.png"),
          path:'/joinLottery/details'
        },
        {
          name: "我发布的抽奖活动",
          img: require("./../assets/img/release.png"),
          path:'/createLottery/details'
        },
      ],
    };
  },
   methods:{
        myCheck(item){
            this.$router.push(item.path)
        }
    }
};
</script>
<style scoped>
.content {
  margin: 10px auto;
}
.van-cell {
  border-bottom: 1px solid #ebedf0;
}
.van-cell__title {
  line-height: 35px;
  height: 35px;
  margin-left: 10px;
}
</style>